import { useCartService } from '@skin-seoul/service';
import React from 'react';
import { CartWithItemView } from './views/CartWithItemView';
import { CartEmptyView } from './views/CartEmptyView';
import type { Currency } from '@skin-seoul/service';
import { useMutationLoading } from '@skin-seoul/utils';
import { CART_QUERY_KEYS } from '@skin-seoul/service';
import CartLoaderBackdrop from './components/CartLoaderBackdrop';
import { Condition } from '@skin-seoul/utils';
type ShoppingBagDrawerContentProps = {
  currency: Currency;
  onClickContinueShopping: () => void;
  ImageComponent?: React.ComponentType<{
    src: string;
    alt: string;
    width: number;
    height: number;
  }>;
  /**
   * Custom Link component to use for navigation.
   * Useful for injecting Next.js Link in webapp or other routing solutions.
   * @default Link from @skin-seoul/design-system
   */
  linkComponent?: React.ElementType;
};
const ShoppingBagDrawerContent = ({
  currency,
  onClickContinueShopping,
  ImageComponent,
  linkComponent
}: ShoppingBagDrawerContentProps) => {
  const {
    useGetCartSuspenseQuery
  } = useCartService();
  const {
    data
  } = useGetCartSuspenseQuery({
    currency
  });
  const isLoading = useMutationLoading(CART_QUERY_KEYS.default());
  return <>
      <Condition expression={isLoading} then={<CartLoaderBackdrop />} data-sentry-element="Condition" data-sentry-source-file="ShoppingBagDrawerContent.tsx" />
      {data?.cart?.item?.length ? <CartWithItemView currency={currency} ImageComponent={ImageComponent} linkComponent={linkComponent} /> : <CartEmptyView onClickContinueShopping={onClickContinueShopping} />}
    </>;
};
export default ShoppingBagDrawerContent;